module.exports = {
    stringToSlug: (str) => str.replaceAll(' ', '-').toLowerCase(),
}
